<template>
  <div id="table-wrap">
    <el-table
      :ref="refName"
      :show-header="showHeader"
      :data="tableData"
      :header-cell-style="tableHeaderColor"
      :style="tableWidth"
      :height="tableHeight"
      @select="selectOpt"
      @select-all="selectAll"
      @sort-change="sortMethod"
      @filter-change="filtersHandle"
    >
      <!-- 展开详情 -->
      <el-table-column type="expand" fixed="left" v-if="expand">
        <template slot-scope="scope">
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-if="scope.row.paragraphs"
          >
            <pre
              style="text-align: center"
              v-if="scope.row.paragraphs.length > 0"
              >{{ scope.row.paragraphs.join('\n') }}</pre
            >
            <pre
              style="text-align: center"
              v-if="
                scope.row.paragraphs.length === 0 &&
                  scope.row.content.length > 0
              "
              >{{ scope.row.content.join('\n') }}</pre
            >
            <pre
              style="text-align: center; color: #999"
              v-if="
                scope.row.paragraphs.length === 0 &&
                  scope.row.content.length === 0
              "
            >
暂无诗词内容</pre
            >
          </el-form>
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-if="scope.row.translations"
          >
            <pre style="text-align: center">{{
              scope.row.translations.join('\n')
            }}</pre>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column
        type="selection"
        align="center"
        v-if="selectCtrl"
        :selectable="selectable"
        width="50"
      >
      </el-table-column>

      <el-table-column
        type="index"
        align="center"
        :label="labelNo"
        fixed="left"
        v-if="orderCtrl"
        :key="Math.random()"
        width="50"
      >
        <template slot-scope="scope">
          <span v-if="!!pageSize">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</span>
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="{ prop, label, width, btn, obj } in tableProps"
        align="center"
        show-overflow-tooltip
        :prop="prop"
        :key="prop"
        :columnKey="prop"
        :label="label"
        :width="width"
        :sortable="sortable.includes(prop) ? 'custom' : false"
        :filters="isFilters(prop)"
      >
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span v-if="prop === 'useinfo.lastTime'">{{
              scope.row | filterObj(prop) | filterDate
            }}</span>
            <span v-else-if="prop === 'useinfo.enable'">{{
              scope.row | filterObj(prop) ? '是' : '否'
            }}</span>
            <span v-else>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div
            class="omitText"
            v-else-if="
              prop === 'updated_at' ||
                prop === 'created_at' ||
                prop === 'createdAt' ||
                prop === 'updatedAt' ||
                prop === 'publishAt' ||
                prop === 'endAt' ||
                prop === 'pay_time' ||
                prop === 'liveAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <div class="omitText" v-else-if="prop === 'cbPageCount'">
            <span v-if="scope.row['pageNameList'] !== null">{{
              scope.row['pageNameList'].pageNameList.length
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'status'">
            <span v-if="scope.row['status'] !== null">{{
              scope.row['status'] === 1 ? '正常' : '回收站'
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'cbType'">
            <span v-if="scope.row['type'] !== null">{{
              scope.row['type'] === 1 ? '笔记' : '文件夹'
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'associationType'">
            <span v-if="scope.row['association'] !== null">{{
              scope.row['association'].associationType ? '阅读笔记' : '本地笔记'
            }}</span>
            <span v-else>-</span>
          </div>
          <div
            class="omitText"
            v-else-if="prop === 'notePointSize' || prop === 'size'"
          >
            <span v-if="scope.row[prop] !== null">{{
              scope.row[prop] | renderSize
            }}</span>
            <span v-else>-</span>
          </div>

          <span v-else class="omitText">{{
            scope.row[prop] && scope.row[prop] !== null ? scope.row[prop] : '-'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tableBtn.length"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <div class="user-table-data-btn">
            <template v-for="btn in tableBtn">
              <el-button
                :key="btn.type"
                v-if="btn.type === 'checkShape'"
                type="primary"
                size="mini"
                :loading="scope.row.shapeLoading"
                @click="tableHandle(btn.type, scope)"
              >
                {{ btn.label }}
              </el-button>
              <el-button
                :key="btn.type"
                v-else
                type="primary"
                size="mini"
                @click="tableHandle(btn.type, scope)"
              >
                {{ btn.label }}
              </el-button>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResizeMixin from '@/mixins/resize'
import DelPopup from '@/components/delPopup'

export default {
  components: {
    DelPopup
  },
  computed: {
    ...mapGetters(['hasData', 'delPopup', 'userInfo']),
    labelNo() {
      return this.$t('commonMsg.No')
    }
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: 'appTable'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    tableWidth: {
      type: String,
      default: 'width:100%'
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array
    },
    tableBtn: {
      type: Array,
      default: () => []
    },
    selectCtrl: {
      type: Boolean,
      default: false
    },
    orderCtrl: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    expand: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Array,
      default: () => []
    },
    pageSize: Number
  },

  data() {
    return {
      selectDataIds: [],
      selectData: [],
      scopeItem: null
    }
  },

  filters: {
    filterObj(obj, value) {
      let temp = value.split('.')
      if (temp.length === 2 && obj[temp[0]]) {
        return obj[temp[0]][temp[1]]
      } else if (temp.length === 3 && obj[temp[0]] && obj[temp[0]][temp[1]]) {
        return obj[temp[0]][temp[1]][temp[2]]
      }
    }
  },

  methods: {
    sortMethod({ prop, order }) {
      this.$emit('tableSortOrder', { prop, order })
    },
    clearSort() {
      this.$refs[this.refName].clearSort()
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f7f7f7;font-weight: 500;'
      }
    },

    btnStyle(item) {
      let className
      switch (item) {
        case this.$t('commonMsg.checkDetails'):
        case this.$t('commonMsg.edit'):
          className = 'checkDetailsBtn'
          break
        case this.$t('commonMsg.del'):
        case this.$t('commonMsg.destroy'):
        case this.$t('commonMsg.correction'):
        case this.$t('sale.gift.handle'):
        case 'Token失效':
        case '笔记PDF修正':
        case 'OSS查询':
        case 'CB查询':
          className = 'delBtn'

          break

        default:
          break
      }
      return className
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, 'tableSort')
    },

    switchChange(scope) {
      this.emitEvn(null, scope, 'switchChange')
    },

    giftHandle(type, scope) {
      if (type === 'commonMsg.del') {
        this.scopeItem = scope
        this.$store.commit('windowHandle', 'delPopup')
      } else {
        this.emitEvn(this.$t(type), scope, 'tableHandle')
      }
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      if (type === this.$t('commonMsg.del')) {
        this.scopeItem = scope
        this.$store.commit('windowHandle', 'delPopup')
      } else {
        this.emitEvn(type, scope, 'tableHandle')
      }
    },

    //  确认删除
    deleteHandle() {
      this.emitEvn(this.$t('commonMsg.del'), this.scopeItem, 'tableHandle')
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type || '',
        data: scope
      }
      this.$emit(evn, obj)
    },

    selectOpt(selection, row) {
      if (this.selectDataIds.includes(row.id)) {
        let idx = this.selectDataIds.indexOf(row.id)
        this.selectDataIds.splice(idx, 1)
        this.selectData.splice(idx, 1)
      } else {
        this.selectDataIds = [...this.selectDataIds, row.id]
        this.selectData = [...this.selectData, row]
      }

      this.sendSelectData()
    },

    selectAll(selection) {
      if (!selection.length) {
        this.selectDataIds = []
        this.selectData = []
        return
      }
      for (let item of selection) {
        if (!this.selectDataIds.includes(item.id)) {
          this.selectDataIds.push(item.id)
          this.selectData.push(item)
        }
      }

      this.sendSelectData()
    },

    sendSelectData() {
      this.$emit('tableSelection', {
        data: this.selectData,
        ids: this.selectDataIds
      })
    },

    selectable(row, index) {
      return this.hasData.includes(row.id) ? false : true
    },

    toggleSelection() {
      if (!this.selectDataIds.length) return
      for (let row of this.tableData) {
        if (this.selectDataIds.includes(row.id))
          this.$refs[this.refName].toggleRowSelection(row, true)
      }
    },

    isFilters(prop) {
      switch (prop) {
        case 'contentType':
          return [
            {
              text: '推送手写模板(push_writeTemplate)',
              value: 'push_writeTemplate'
            },
            {
              text: '推送文件(digital_content)',
              value: 'digital_content'
            },
            {
              text: '通知刷新推送列表(refresh_push)',
              value: 'refresh_push'
            },
            {
              text: '通知刷订阅送列表(refresh_subsription)',
              value: 'refresh_subsription'
            },
            {
              text: '推送屏保(push_screensaver)',
              value: 'push_screensaver'
            },
            {
              text: '推送网页链接(webpage_content)',
              value: 'webpage_content'
            }
          ]

        default:
          return null
      }
    },

    filtersHandle(obj) {
      let key = Object.keys(obj)
      this.$emit('filterEvn', { obj, key: key[0] })
    }
  }
}
</script>

<style lang="scss" scoped>
#table-wrap {
  height: 100%;
  .appTable-move {
    > i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }
    .move-up {
      background: url('~@/assets/img/cmb_move_up.png') no-repeat;
    }
    .move-down {
      background: url('~@/assets/img/cmb_move-down.png') no-repeat;
    }
  }
  .green {
    color: green;
  }
  .user-table-data-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
